"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Intercom_1 = __importDefault(require("./Intercom"));
const react_1 = __importStar(require("react"));
const ProviderHoc_1 = __importDefault(require("../../hoc/ProviderHoc"));
const react_redux_1 = require("react-redux");
class IntercomWrapper extends react_1.Component {
    render() {
        const { profile } = this.props;
        const shouldIntercomRender = profile.isLoggedIn && profile.provisioning[DigProvisions.INTERCOM_ENABLED];
        if (!shouldIntercomRender) {
            return null;
        }
        return react_1.default.createElement(Intercom_1.default, Object.assign({}, this.props));
    }
}
function mapStateToProps({ profile, app }) {
    return {
        profile,
        app,
    };
}
exports.default = (0, ProviderHoc_1.default)()((0, react_redux_1.connect)(mapStateToProps)(IntercomWrapper));
